import { call, takeLatest } from 'redux-saga/effects';
import { setAccount } from 'next/lib/crx';
import { INITIALIZE } from 'next/root/actions';

function* initialize({ payload: auth }) {
  try {
    const { accountId, jwt } = auth;
    yield call(setAccount, { accountId, jwt });
  } catch {
    // TODO: Handle error
  }
}

export default function* saga() {
  yield takeLatest(INITIALIZE, initialize);
}
